module.exports = __webpack_public_path__ + "img/8.c2c0cc58.png";